$('.infoGallery').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
  $('.infoGalleryNav').find('.slick-slide').removeClass('slick-current');
  $('.infoGalleryNav').find(`[data-slick-index="${nextSlide}"]`).addClass('slick-current');
});

$('.infoGalleryNav').on('click', '.slick-slide', function () {
  const index = $(this).data('slick-index');
  $('.infoGallery').slick('slickGoTo', index);
});

// Инициализация галерей
$('.infoGallery').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
  infinite: true,
  autoplay: true,
});

$('.infoGalleryNav').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
  infinite: true,
  focusOnSelect: true,
});

// $('.infoGallery').slick({
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   arrows: false,
//   dots: false,
//   infinite: true,
//   asNavFor: '.infoGalleryNav',
//   autoplay: true,
// });

// $('.infoGalleryNav').slick({
//   slidesToShow: 4,
//   slidesToScroll: 1,
//   arrows: false,
//   dots: false,
//   asNavFor: '.infoGallery',
//   infinite: true,
//   focusOnSelect: true,
// });

if (innerWidth > 1420) {
  $('.infoServiceItemSlide').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: true,
    autoplay: true,
    // autoplaySpeed: 15000,
    // responsive: [
    //     {
    //         breakpoint: 992,
    //         settings: {
    //             adaptiveHeight: true,
    //             speed: 300,
    //         }
    //     }
    // ]
  });
}
if (innerWidth < 1420) {
  $('.infoServiceItemSlideWrap').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: true,
    // autoplay: true,
  });
}


// Перевод svg в инлайновый вид для измениния их цвета
$('img.img-svg').each(function () {
  var $img = $(this);
  var imgClass = $img.attr('class');
  var imgURL = $img.attr('src');
  $.get(imgURL, function (data) {
    var $svg = $(data).find('svg');
    if (typeof imgClass !== 'undefined') {
      $svg = $svg.attr('class', imgClass + ' replaced-svg');
    }
    $svg = $svg.removeAttr('xmlns:a');
    if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
      $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
    }
    $img.replaceWith($svg);
  }, 'xml');
});


$('.info__nav_mob_title').click(function () {
  $(this).closest('.info__nav-inner').toggleClass('_open_nav');
});

$('.info__nav-item-wrap').click(function () {

  let info_nav_tab_id = $(this).data('id'),
    info_nav_item_html = '';

  if ($(window).width() <= 868) {
    info_nav_item_html = $(this).html();
    $('.info__nav_mob_title ._left').html(info_nav_item_html);
    $('.info__nav-item-wrap._active, .info__nav-text-wrap_content._active').removeClass('_active');
    $(this).addClass('_active');
    $('.info__nav-text-wrap_content[data-id="' + info_nav_tab_id + '"]').addClass('_active');
    $(this).closest('.info__nav-inner').removeClass('_open_nav');
  } else {
    if (!$(this).hasClass('_active')) {
      $('.info__nav-item-wrap._active, .info__nav-text-wrap_content._active').removeClass('_active');
      $(this).addClass('_active');
      $('.info__nav-text-wrap_content[data-id="' + info_nav_tab_id + '"]').addClass('_active');
    }
  }


});


$(document).mouseup(function (e) {

  let info_nav_title = $('.info__nav_mob_title'),
    info_nav_open = $('.info__nav-inner._open_nav .info__nav');
  if (!info_nav_title.is(e.target) && info_nav_title.has(e.target).length === 0
    && !info_nav_open.is(e.target) && info_nav_open.has(e.target).length === 0) {
    $('.info__nav-inner._open_nav').removeClass('_open_nav');
  }

});